import { IProcessorState } from 'components/RichTextEditor/processor/constants'
import {
  getSelection,
  getText,
} from 'components/RichTextEditor/processor/selectors/textProcessorSelectors'

const getTextAfter = (text: string, char: string): string => {
  const index = text.lastIndexOf(char)
  if (index >= 0) {
    return text.slice(index + 1)
  }
  return text
}

const getTextWith = (text: string, char: string): string => {
  const index = text.lastIndexOf(char)
  if (index >= 0) {
    return text.slice(index)
  }
  return ''
}

export const getExpression = (state: IProcessorState, prefix?: string): string => {
  const selection = getSelection(state)
  const text = getText(state)
  if (selection.length > 0) {
    return ''
  }
  const textBeforeSelection = text.slice(0, selection.start)
  const line = getTextAfter(textBeforeSelection, '\n')
  if (prefix) {
    return getTextWith(line, prefix)
  }
  return line
}
